/*
 * @Author: Ryan
 * @Date: 2026-01-27
 * @Description: UGC How To Section - 如何用 AI 制作 UGC 视频
 */
import Image from 'next/image';
import React from 'react';

import styles from './index.module.scss';

interface StepData {
  number: number;
  title: string;
  description: string;
}

const STEPS: StepData[] = [
  {
    number: 1,
    title: 'Enter a Prompt or Upload an Image',
    description:
      'Write a description of the video you want to create, or upload a product image or reference visual. FalcoCut AI can generate a UGC-style video from text or animate your image into a video.',
  },
  {
    number: 2,
    title: 'Add Your Script',
    description:
      'Choose from AI video models like Sora, Veo, and Kling, each offering different motion styles, visual realism, and pacing, so you can generate videos that best fit product showcases, UGC ads, or short-form content.',
  },
  {
    number: 3,
    title: 'Set Duration and Output Settings',
    description:
      'Choose how long your video should be and adjust key output settings, such as resolution and aspect ratio, to match your use case for ads, social media, or product showcases.',
  },
  {
    number: 4,
    title: 'Generate and Share Your Video',
    description:
      "Click Start to generate your video and download it once it's ready. You can share your final video across ads and social platforms.",
  },
];

const IMAGE_URL =
  'https://assets.falcocut.ai/ai-ugc-video-generator/how-to-make-a-ugc-video-with-ai.webp';

const StepItem: React.FC<StepData> = ({ number, title, description }) => (
  <div className={styles.stepItem}>
    <div className={styles.stepNumber}>{number}</div>
    <div className={styles.stepContent}>
      <h3 className={styles.stepTitle}>{title}</h3>
      <p className={styles.stepDescription}>{description}</p>
    </div>
  </div>
);

const UGCHowTo: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.title}>How to Make a UGC Video with AI</h2>

        <div className={styles.content}>
          {/* 左侧图片 */}
          <div className={styles.imageWrapper}>
            <div className={styles.imageContainer}>
              <Image
                src={IMAGE_URL}
                alt="How to Make a UGC Video with AI"
                width={560}
                height={480}
                className={styles.image}
              />
            </div>
          </div>

          {/* 右侧步骤 */}
          <div className={styles.stepsWrapper}>
            {STEPS.map((step) => (
              <StepItem key={step.number} {...step} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UGCHowTo;
